import { render, staticRenderFns } from "./sgcontent.vue?vue&type=template&id=644b1ef4&scoped=true"
import script from "./sgcontent.vue?vue&type=script&lang=js"
export * from "./sgcontent.vue?vue&type=script&lang=js"
import style0 from "./sgcontent.vue?vue&type=style&index=0&id=644b1ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644b1ef4",
  null
  
)

export default component.exports